// core
import { Component, EventEmitter, Input, Output } from '@angular/core';
// own
import { BankService } from '@manager-app/storage/service/bank.service';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-bank-search',
    templateUrl: './bank-search.component.html',
    styleUrls: ['./bank-search.component.css'],
    imports: [NgClass, FormsModule, NgIf, NgFor, TranslocoPipe]
})
export class BankSearchComponent {
  @Output() update = new EventEmitter<any>();
  _id;
  @Input()
  set id(val) {
    if (val) {
      this.getItembyId(val);
    }
  }

  isLoading = false;
  items = [];
  item = '';
  focused = false;
  selectedItem = false;

  constructor(
    private bankService: BankService,
  ) {
  }

  private setCurrentItem(val) {
    this.item = val;
    this.selectedItem = true;
  }

  public clear() {
    setTimeout(() => {
      this.focused = false;
    }, 300);
  }

  public showOpen(): void {
    this.focused = true;
  }

  public selectItem(item) {
    this.item = item.text;
    this.selectedItem = true;
    this.update.emit(item);
  }

  public typed(event): void {
    this.focused = true;
    if (this.item && this.item.length > 1) {
      this.getItem(this.item);
    } else {
      this.items = [];
    }
  }

  public removed(): void {
    this.selectedItem = false;
    this.item = '';
    this.update.emit(null);
  }

  private async getItembyId(id): Promise<void> {
    const result = await this.bankService.getBank(id);
    if (result) {
      const name = result.name;
      this.selectedItem = true;
      this.item = `${name}`;
    }
  }

  private async getItem(searchText: string) {
    this.isLoading = true;
    this.selectedItem = false;

    if (searchText) {
      try {
        const result = await this.bankService.getBankList({query: searchText});
        const banks = result.list || [];
        const arr = [];

        banks.forEach(item => {
          arr.push({
            id: item.id,
            text: `${item.name}`
          });
        });

        this.items = arr;
      } finally {
        this.isLoading = false;
      }
    } else {
      this.items = [];
      this.isLoading = false;
    }
  }

}
